import {PortalType} from "@studyportals/domain-client";
import {defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig} from "nuxt/app";
import type {RouteLocationNormalized} from "vue-router"
import {isCatchAllRoute} from "@utils/route-helpers";
import {ROUTE_PREFIX} from "@generator/config/route-prefix";
import {FilterType} from "@domain/enums/FilterType";
import {AttendanceFilterValue} from "@studyportals/search-api-interface"; // TODO: Remove before production release


export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) return;

	if (!isCatchAllRoute(to) && to.params[FilterType.EDUCATION_LEVEL] === undefined) return;

	const matchedPortalType = useRuntimeConfig().public.portalType;
	const matchedPortalTypeBasePath = matchedPortalType ? portalTypeBasePaths[matchedPortalType] : null;

	if (!matchedPortalTypeBasePath) return;

	if(matchedPortalType === PortalType.DISTANCE_LEARNING){

		const at = to.query[FilterType.ATTENDANCE] || '';
		if(at.includes(AttendanceFilterValue.ONLINE) && at.includes(AttendanceFilterValue.BLENDED)) return;

	} else if(to.path.startsWith(matchedPortalTypeBasePath as string)) {
		return;
	}

	const query = to.query;

	if (matchedPortalType === PortalType.DISTANCE_LEARNING) {
		query[FilterType.ATTENDANCE] = [AttendanceFilterValue.ONLINE, AttendanceFilterValue.BLENDED].join(',');
	}

	to.query = query;

	return navigateTo({path: matchedPortalTypeBasePath, query}, {redirectCode: 301});
})

// TODO: Remove ROUTE_PREFIX usage before production release - these should be '/search/master' etc.
const portalTypeBasePaths: Record<string, string> = {
	[PortalType.MASTER]: `${ROUTE_PREFIX}/search/master`,
	[PortalType.BACHELOR]: `${ROUTE_PREFIX}/search/bachelor`,
	[PortalType.PHD]: `${ROUTE_PREFIX}/search/phd`,
	[PortalType.DISTANCE_LEARNING]: `${ROUTE_PREFIX}/search/distance-learning`,
	[PortalType.SHORT]: `${ROUTE_PREFIX}/search/course`
}
